import { retreiveProductMetafields } from '../services/products';
import { addItemsToCart } from '../services/cart';
import { isFinalSale, retrieveSku, isUnreturnable } from '../utils/product';
import { replaceWords } from '../services/filter-value';

const tabletMedia = window.matchMedia('screen and (max-width: 1024px)');

const IMAGE_MEDIA = {
  // media: imageWidth
  'max-width: 400px': 340,
  'max-width: 1024px': 500,
  'min-width: 1200px': 1100,
};

const FEATURED_IMAGE_MEDIA = {
  'max-width: 400px': 600,
  'max-width: 1024px': 750,
  'min-width: 1200px': 1100,
};

const formatPrice = (number) => {
  if (isNaN(number)) return number
  const currentPrice = +number;
  const priceWithoutDecimal = +currentPrice.toFixed(0)
  const formatedPrice = priceWithoutDecimal.toLocaleString()
  return `${localizationCurrencyCode} ${formatedPrice}`;
};


export const attachProductItemEvents = (renderedState, containerEl, isRebuy) => {
  const itemsState = renderedState;
  if (!containerEl) return;
  Object.keys(itemsState).forEach((productId) => {
    const productItem = containerEl.querySelector(`[data-id="${productId}"]`);
    if (!productItem) return;
    itemsState[productId].element = productItem;
    const cartBtn = productItem.querySelector('.btn-add-to-cart');
    const backdrop = productItem.querySelector('.product-item__backdrop');
    const options = Array.from(productItem.querySelectorAll('[data-option]'));
    const dropItems = Array.from(productItem.querySelectorAll('[data-value]'));
    cartBtn.onclick = () => onAddToCart(cartBtn, productId, itemsState, isRebuy);
    dropItems.forEach((dropItem) => (
      dropItem.onclick = () => onSelectOption(dropItem, productId, itemsState)
    ));
    backdrop.onclick = () => {
      options.forEach((opt) => opt.classList.remove('active'));
      backdrop.classList.remove('active');
    };
    options.forEach((opt) => (
      [opt, opt.nextElementSibling].forEach((el) => (
        el.onclick = () => {
          opt.classList.toggle('active');
          backdrop.classList.toggle('active');
        }
      ))
    ));
  });
};

const createImageMediaList = (image, featuredCard) => {
  const mediaMap = featuredCard ? FEATURED_IMAGE_MEDIA : IMAGE_MEDIA;
  const mediaList = Object.entries(mediaMap).map(([media, imageWidth]) => (
    `
      <source 
        srcset="${window.resizeImage(image, imageWidth)}" 
        media="(${media})"
      >
    `
  ));
  return mediaList.join('\n');
};

export const getProductItemBody = (product, index, renderedState, isFeaturedCard) => {
  const defaultVariantId = !product.options.length ? `?variant=${product.variants[0].id}` : '';
  const featuredClass = isFeaturedCard ? ' product-item--featured' : '';
  const productColor = product.variants[0].title.split(' / ')[0];
  const specialTagNewIn = product.tags ? product.tags.includes('newin') : '';
  const specialTagLimited = product.tags ? product.tags.includes('limitededition') : '';
  // Determine if any label uses secondary style for parent class and product has ITA tag
  const { primary, secondary, tertiary, quaternary } = window.productCardSettings?.productLabels || {};
  const hasSecondaryStyle = (primary?.style === 'secondary' || 
                           secondary?.style === 'secondary' || 
                           tertiary?.style === 'secondary' || 
                           quaternary?.style === 'secondary') && 
                           product.tags && product.tags.includes('ITA');
  const styleClass = hasSecondaryStyle ? ' product-item--label-secondary product-item__body--label-secondary' : '';

  setProductInitialState(product, renderedState);
  return `
    <div 
      class="product-item${featuredClass}${styleClass}" 
      data-id="${product.id}" 
      data-color="${productColor.toUpperCase()}"
    >
      <div class="product-item__body">
        ${product.compareAtPrice
    ? `<span class="product-item__tag">SALE</span>`
    : ''
}
        <a href="/products/${product.handle}${defaultVariantId}" class="product-item__link">
          ${renderImages(product.images, isFeaturedCard, product.title)}
        </a>
        <div class="product-item__backdrop"></div>
        <div class="product-item__toolbar">
          ${renderVariantOptions(product, renderedState)}
        </div>
        <button class="btn-add-to-cart">
          Add to bag
        </button>
      </div>
      <div class="product-item__footer">
        <a href="/products/${product.handle}${defaultVariantId}" class="product-item__link">
          <span class="product-title text">${replaceWords(product.title)}</span>
        </a>
        <div class="product-item__price-group">
          <div class="producti-item__price-inner">
            <span class="product-price">$${formatPrice(product.price)}</span>
            ${product.compareAtPrice
    ? `
                <span class="product-price product-price--real">
                  $${formatPrice(product.compareAtPrice)}
                </span>
              `
    : ''
}
          </div>
        </div>

        <div class="labels-wrapper">
          ${specialTagNewIn || specialTagLimited
    ? `<div class="labels">
                ${specialTagNewIn
    ? `<a href="/products/${product.handle}${defaultVariantId}">
                      <span class="new-in-label label">New In</span>
                     </a>`
    : ''
}
                ${specialTagLimited
    ? `<a href="/products/${product.handle}${defaultVariantId}">
                      <span class="limited-label label">Limited Edition</span>
                    </a>`
    : ''
}
              </div>`
    : ''
}
        </div>
        
      </div>
    </div>
  `;
};

const isVideoPlaying = (videoEl) => (
  videoEl.currentTime > 0
  && !videoEl.paused
  && !videoEl.ended
  && videoEl.readyState > videoEl.HAVE_CURRENT_DATA
);

const toggleMobileVideo = (videoEl, productEl) => {
  if (!tabletMedia.matches) return;
  if (productEl.classList.contains('playing')) {
    return videoEl.pause();
  }
  if (!isVideoPlaying(videoEl)) {
    videoEl.play();
  }
};

const playVideo = (videoEl) => {
  if (!isVideoPlaying(videoEl) && !tabletMedia.matches) {
    videoEl.play();
  }
};

const pauseVideo = (videoEl) => {
  // if (!isVideoPlaying(videoEl)) return;
  if (tabletMedia.matches) return;
  videoEl.pause();
};

const availableColors = function (metafields, renderedState) {
  const products = Array.from(document.querySelectorAll('.product-item'));
  metafields.forEach((meta) => {
    let numberOfColors;
    const product = products.find((product) => product.dataset.id === meta.productId);

    if (
      window.collectionSettings && 
      meta.metafields.metafield_product_handle && 
      window.collectionSettings.color_available
    ) {
      if (meta.metafields.colors_available_message_meta) {
        product.querySelector('.product-item__price-group')
          .insertAdjacentHTML(
            window.collectionSettings.color_available_message_position,
            `<a href="/products/${renderedState[meta.productId].productBody.handle}">
        <span class="product-color-link">${meta.metafields.colors_available_message_meta}</span>
      </a>`,
          );
      } else if (window.collectionSettings.metafield_available_color) {
        product.querySelector('.product-item__price-group')
          .insertAdjacentHTML(
            window.collectionSettings.color_available_message_position,
            `<a href="/products/${renderedState[meta.productId].productBody.handle}"
        <span class="product-color-link">${window.collectionSettings.metafield_available_color}</span>
      </a>`,
          );
      } else {
        numberOfColors = meta.metafields.metafield_product_handle.split(',').length + 1;
        product.querySelector('.product-item__price-group')
          .insertAdjacentHTML(
            window.collectionSettings.color_available_message_position,
            `<a href="/products/${renderedState[meta.productId].productBody.handle}"
        <span class="product-color-link"> ${numberOfColors} ${numberOfColors > 1 ? "Colors" : "Color"}
        </span>
      </a>`,
          );
      }
    }
  });
};

export const renderVideos = async (products, renderedState) => {
  const metafields = await retreiveProductMetafields(products);
  availableColors(metafields, renderedState);

  const productsWithVideo = [];
  metafields.forEach((meta) => {
    if (!('metafield_video_url' in meta.metafields)) return;
    const { metafield_video_url } = meta.metafields;
    const productElement = renderedState[meta.productId].element;
    const videoUrlArr = metafield_video_url.split(',');
    let videoUrl = videoUrlArr.find((url) => {
      const colorLabel = url.split('|')[0].toUpperCase();
      if (colorLabel.includes('-')) {
        return colorLabel.replace(/-/g, ' ').includes(productElement.dataset.color);
      }
      return colorLabel.includes(productElement.dataset.color);
    });
    if (!videoUrl) return;
    videoUrl = videoUrl.split('|')[1];
    const productItemBody = productElement.querySelector('.product-item__body');
    const imagesContainer = productItemBody.querySelector('.product-item__link');
    if (imagesContainer.children.length > 1) {
      imagesContainer.children[1].remove();
    }
    const videoLabelEl = document.createElement('div');
    videoLabelEl.className = 'product-item__label';
    videoLabelEl.innerHTML = `
      <svg class="product-item__icon product-item__icon--play" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polygon fill="none" stroke="#444" stroke-width="2" points="3 22 21 12 3 2"></polygon></svg>
      <svg class="product-item__icon product-item__icon--pause" stroke="#444" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>
      <span>Video</span>
    `;
    const videoEl = document.createElement('video');
    videoEl.playsInline = true;
    videoEl.className = 'product-item__media product-item__media--video';
    videoEl.muted = true;
    videoEl.src = videoUrl;
    videoEl.loop = true;
    videoEl.autoplay = false;
    videoEl.setAttribute('preload', 'auto');
    videoEl.setAttribute('type', 'video/mp4');
    productItemBody.insertAdjacentElement('afterbegin', videoLabelEl);
    imagesContainer.insertAdjacentElement('beforeend', videoEl);
    videoLabelEl.addEventListener('click', () => toggleMobileVideo(videoEl, productElement));
    productItemBody.addEventListener('mouseenter', () => playVideo(videoEl, productElement));
    productItemBody.addEventListener('mouseleave', () => pauseVideo(videoEl, productElement));
    videoEl.addEventListener('play', () => onVideoPlay(productElement, videoLabelEl));
    videoEl.addEventListener('pause', () => onVideoPause(productElement, videoLabelEl));
    videoEl.addEventListener('contextmenu', e => e.preventDefault());
    productsWithVideo.push(productElement);
  });
  createVideoObserver(productsWithVideo);
};

const onVideoPlay = (productElement, videoLabelEl) => {
  const labelText = videoLabelEl.querySelector('span');
  labelText.innerHTML = 'Pause';
  productElement.classList.add('playing');
};

const onVideoPause = (productElement, videoLabelEl) => {
  const labelText = videoLabelEl.querySelector('span');
  labelText.innerHTML = 'Video';
  productElement.classList.remove('playing');
};

const observeVideos = (entries) => {
  if (!tabletMedia.matches) return;
  entries.forEach((entry) => {
    const video = entry.target.querySelector('video');
    const isPlaying = isVideoPlaying(video);
    if (isPlaying && !entry.isIntersecting) {
      pauseVideo(video, entry.target);
    }
  });
};

const createVideoObserver = (productEls) => {
  const styles = getComputedStyle(document.documentElement);
  const headerHeight = styles.getPropertyValue('--header-height').split('px')[0];
  const filtersHeight = styles.getPropertyValue('--filters-height').split('px')[0];
  const observer = new IntersectionObserver(observeVideos, {
    rootMargin: `-${+headerHeight + +filtersHeight + 30}px`,
  });
  productEls.forEach((productEl) => observer.observe(productEl));
};

const renderImages = (images, featuredCard, productTitle) => (
  images.reduce((prevImg, { originalSrc }) => (
    `${prevImg}
        <picture class="product-item__media product-item__media--image">
          ${createImageMediaList(originalSrc, featuredCard)}
          <img 
            class="product-item__media product-item__media--image"
            loading="lazy"
            srcset="${window.resizeImage(originalSrc, 800)}"
            alt="${productTitle}"
          >
        </picture>
      `
  ), '')
);

const renderVariantOptions = (product, renderedState) => (
  createOptionsList(product).reduce((optPrev, opt, optIndex, self) => {
    // option selection initial state
    renderedState[opt.productId].options[opt.name] = null;

    const optionItems = opt.values.reduce((valPrev, val) => {
      const disabledClass = (self.length === 1 && !val.available) ? ' disabled' : '';
      return `${valPrev}
        <li
          class="product-item__dropdown__item${disabledClass}" 
          data-available="${val.available}" 
          data-id="${val.id}"
          data-value="${val.value.toUpperCase()}"
        >
          &nbsp;${val.value}&nbsp;
        </li>
      `;
    }, '');

    return `${optPrev}
      <div class="collections__option-wrapper">
        <button 
          class="product-item__option"
          ${optIndex > 0 ? 'disabled' : ''} 
          data-option="${opt.name}"
        >
          <span>${opt.name}</span>
          <svg class="product-item__option__icon" role="presentation" viewBox="0 0 19 12">
            <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
          </svg>
        </button>
        <ul class="product-item__dropdown">
          ${optionItems}
        </ul>
      </div>
    `;
  }, '')
);

const getVariantByTitle = (variants, ...options) => (
  variants.find((variant) => {
    const title = variant.options.join(' ');
    const optionsStr = options.join(' ');
    if (!optionsStr.match(/^\d+$/) && /\d/.test(optionsStr)) {
      return title.toUpperCase().indexOf(optionsStr.toUpperCase()) > -1;
    }
    const selectedOptionRegex = new RegExp(`\\b(${optionsStr})\\b`, 'gi');
    return !!title.match(selectedOptionRegex);
  })
);

const updateAvailableVariants = (nextOptionContainer, prevOptionName, id, renderedState) => {
  if (!nextOptionContainer) return;
  const dropdownItems = Array.from(
    nextOptionContainer.nextElementSibling.querySelectorAll('[data-value]'),
  );
  dropdownItems.forEach((dropItem) => {
    const activeProdItem = renderedState[id];
    const previousSelectedOption = activeProdItem.options[prevOptionName];
    const nextOption = dropItem.dataset.value;
    const variantByTitle = getVariantByTitle(
      activeProdItem.variants,
      previousSelectedOption,
      nextOption,
    );

    dropItem.classList[
      variantByTitle && (variantByTitle.quantityAvailable || variantByTitle.availableForSale)
        ? 'remove' : 'add'
    ]('disabled');
  });
};

const enableNextOption = (prevOption) => {
  const nextOptionWrapper = prevOption.parentNode.nextElementSibling;
  if (!nextOptionWrapper) return;
  const nextOptionContainer = nextOptionWrapper.querySelector('[data-option]');
  nextOptionContainer.removeAttribute('disabled');
  return nextOptionContainer;
};

const setActiveVariant = (nextOption, id, renderedState) => {
  if (nextOption) return;
  const { variants, options } = renderedState[id];
  const variantByTitle = getVariantByTitle(
    variants,
    ...Object.values(options),
  );
  renderedState[id].selectedVariant = variantByTitle;
};

const updateProductUrl = (nextOption, id, renderedState) => {
  if (nextOption || !renderedState[id].selectedVariant) {
    return;
  }
  const product = renderedState[id].element;
  Array.from(product.querySelectorAll('a')).forEach((el) => {
    const url = new URL(el.href);
    const params = new URLSearchParams(url.search);
    params.set('variant', renderedState[id].selectedVariant.id);
    url.search = params.toString();
    el.setAttribute('href', url);
  });
};

const setProductInitialState = (product, renderedState) => {
  // to cache option selection
  renderedState[product.id] = {
    variants: product.variants,
    productBody: product,
    options: {},
    selectedVariant: product.variants.length === 1 ? product.variants[0] : null,
  };
};

const onSelectOption = (item, productId, renderedState) => {
  if (item.classList.contains('disabled')) return;
  const optionContainer = item.parentNode.previousElementSibling;
  const { value: optionValue } = item.dataset;
  const { option: optionName } = optionContainer.dataset;
  renderedState[productId].options[optionName] = optionValue;
  optionContainer.querySelector('span').innerHTML = optionValue;
  const nextOption = enableNextOption(optionContainer);
  updateAvailableVariants(nextOption, optionName, productId, renderedState);
  setActiveVariant(nextOption, productId, renderedState);
  updateProductUrl(nextOption, productId, renderedState);
  const addToCartBtn = renderedState[productId].element.querySelector('.btn-add-to-cart');
  const hasEmptyOption = !!getEmptyOptionName(productId, renderedState);
  addToCartBtn.style.visibility = hasEmptyOption ? 'hidden' : 'visible';
};

const getEmptyOptionName = (id, renderedState) => {
  const optionKeys = Object.keys(renderedState[id].options);
  if (!optionKeys.length || renderedState[id].selectedVariant) return null;
  return optionKeys.find(
    (key) => !renderedState[id].options[key],
  );
};

const setAddToCartLabel = (btn, label) => {
  btn.textContent = label;
  setTimeout((btn) => {
    btn.textContent = window.languages.productFormAddToCart || 'Add to bag';
  }, 2000, btn);
};

const createOptionsList = (product) => (
  product.options.map((el) => ({
    productId: product.id,
    name: el.name,
    values: el.values.map((value) => {
      const { id, availableForSale, quantityAvailable } = product.variants.find((v) => (
        !!v.options.find((opt) => opt === value)
      )) || {};
      let variantAvailable = availableForSale;
      if (availableForSale === undefined) {
        variantAvailable = !!quantityAvailable;
      }
      return { value, id, available: variantAvailable };
    }),
  })).filter((opt) => (
    opt.name.toUpperCase() !== 'COLOR'
  ))
);

const pushProductToKlaviyo = (product, selectedVariant) => {
};

const onAddToCart = async (btn, id, renderedState, isRebuy) => {
  const emptyOption = getEmptyOptionName(id, renderedState);
  if (emptyOption) {
    return setAddToCartLabel(btn, `Please, pick a ${emptyOption}`);
  }
  const { selectedVariant } = renderedState[id];
  if (!selectedVariant) {
    return setAddToCartLabel(btn, 'Error, try again');
  }

  const isCartPage = (/cart/i).test(document.body.dataset.templateName);

  const rebuyProperties = {
    _source: 'Rebuy',
    _widget_id: isCartPage ? 16874 : 17054,
    _attribution: isCartPage
      ? 'Rebuy Cart'
      : 'Rebuy Product Page',
  };

  const items = [{
    id: selectedVariant.id,
    quantity: 1,
    properties: {
      _OriginalPrice: formatPrice(selectedVariant.price),
      _CompareAtPrice: selectedVariant.compareAtPrice && formatPrice(selectedVariant.compareAtPrice),
      _ProductSku: retrieveSku(selectedVariant.sku),
      ...(isRebuy ? rebuyProperties : {}),
    },
  }];

  if (isFinalSale(+selectedVariant.price, +selectedVariant.compareAtPrice) || isUnreturnable(renderedState[id])) {
    items[0].properties._finalSale = 'Final Sale';
    items[0].properties["_LPROP"] = 'Final Sale';
  }

  const { options } = renderedState[id].productBody;
  const colorOptionFiltered = options.length !== selectedVariant.options.length;
  const productOptions = [...options];
  if (colorOptionFiltered) {
    productOptions.unshift({ name: 'Color' });
  }
  productOptions.forEach((option, optIndex) => {
    const optionValue = selectedVariant.options[optIndex];
    if (optionValue) {
      items[0].properties[option.name] = optionValue;
    }
  });

  btn.textContent = 'Adding...';
  try {
    await addItemsToCart(items);
    pushProductToKlaviyo(renderedState[id].productBody, selectedVariant);
    setAddToCartLabel(btn, 'Added!');
    const event = {
      bubbles: true,
      detail: {
        variant: selectedVariant.id,
        quantity: 1,
      },
    };
    document.dispatchEvent(new CustomEvent('product:added', event));
  } catch (er) {
    setAddToCartLabel(btn, 'Please, try again');
    console.error(er);
  }
};

function changeSVGColor (isAdded, wishlistEngine) {
  const svgElement = wishlistEngine.querySelector('svg path');
  if (svgElement) {
    if (isAdded) {
      svgElement.style.fill = '#000';
    }else{
      svgElement.style.fill = 'none';
    }
  }
}

function updateVariantId(wishlistEngine, variantId) {
  const wishlistProductIds = window.wishlist_products_ids 
    ? Object.values(window.wishlist_products_ids).flatMap(product => product.variants).map(String) 
    : [];
  if (wishlistEngine) {
    wishlistEngine.setAttribute('data-variant_id', variantId);
    
    const hasVariantId = wishlistProductIds.includes(variantId);
    wishlistEngine.setAttribute('data-added', hasVariantId);
    changeSVGColor(hasVariantId, wishlistEngine);
  }
}

export const wishlistVariantIdUpdate = () => {
  const productItems = document.querySelectorAll('.product-item');

  productItems.forEach(productItem => {
    const wishlistEngine = productItem.querySelector('.wishlist-engine');

    if (!wishlistEngine) {
      console.error("Wishlist engine not found in this product section.");
      return;
    }
    const variantItems = productItem.querySelectorAll('.product-item__dropdown__item');

    variantItems.forEach(item => {
      item.addEventListener('click', function() {
        const variantId = this.getAttribute('data-id');
        if (variantId) {
          updateVariantId(wishlistEngine, variantId);
        } else {
          console.warn("No variant ID found on the clicked item.");
        }
      });
    });
    const initialActiveItem = productItem.querySelector('.product-item__dropdown__item.active');
    if (initialActiveItem) {
      const initialVariantId = initialActiveItem.getAttribute('data-id');
      if (initialVariantId) {
        updateVariantId(wishlistEngine, initialVariantId);
      } else {
        console.warn("No initial variant ID found.");
      }
    }
  });
}

const toggleActiveClasses = (optionWrapper, dropdownWrapper, showDropdown) => {
  const option = optionWrapper.querySelector(".product-item__list");
  const button = dropdownWrapper.querySelector(".product-item__add-to-bag");
  option.classList.toggle("active", showDropdown);
  button.classList.toggle("active", !showDropdown);
};

const updateSelectedOption = (event) => {
  const optionWrapper = event.currentTarget.closest(".product-item__option-wrapper");
  const dropdownWrapper = event.currentTarget.closest(".product-item__dropdown-wrapper");
  toggleActiveClasses(optionWrapper, dropdownWrapper, true);
};

const updateCartButtonAndOption = (event) => {
  const optionWrapper = event.currentTarget.closest(".product-item__option-wrapper");
  const dropdownWrapper = event.currentTarget.closest(".product-item__dropdown-wrapper");
  const optionButton = optionWrapper.querySelector(".product-item__option span");
  const cartButton = dropdownWrapper.querySelector(".product-item__add-to-bag");
  const productItem = optionWrapper.closest(".product-item");
  optionButton.textContent = event.currentTarget.dataset.value;
  toggleActiveClasses(optionWrapper, dropdownWrapper, false);
  cartButton.dataset.selectedVariantId = event.currentTarget.dataset.id;
  const product = window.products[productItem.dataset.id];
  updateProductPrice(product, event.currentTarget.dataset.id);
};


const updateProductPrice = (product, variantId) => {
  const variant = product.variants.find(variant => variant.id == variantId);
  if (variant) {
    const comparePriceElement = document.querySelector(".product-compare-price");
    const priceElement = document.querySelector(".product-price-current");
    priceElement.textContent = formatPrice(variant.price / 100);
    comparePriceElement.classList.toggle('hidden', !variant.compare_at_price);
    comparePriceElement.textContent = variant.compare_at_price ? formatPrice(variant.compare_at_price / 100) : '';
  }
}
const handleAddToCart = async (event) => {
  const cartButton = event.currentTarget;
  const selectedVariantId = cartButton.dataset.selectedVariantId;
  const defaultBtnTextContent = cartButton.textContent;
  if (!selectedVariantId) return;

  const spanText = cartButton.querySelector("span");
  spanText.textContent = "Adding...";

  try {
    await addItemsToCart([{ id: selectedVariantId, quantity: 1 }]);
  } catch (error) {
    console.error("Error adding to cart:", error);
  } finally {
    spanText.textContent = defaultBtnTextContent;
  }
};

export const initializeProductOption = () => {
  const productOptions = document.querySelectorAll(".product-item__option");
  const productDropdownItems = document.querySelectorAll(".product-item__dropdown__item");
  const addToCartButtons = document.querySelectorAll(".product-item__add-to-bag");

  productOptions.forEach(option => option.addEventListener("click", updateSelectedOption));
  productDropdownItems.forEach(item => item.addEventListener("click", updateCartButtonAndOption));
  addToCartButtons.forEach(cartButton => cartButton.addEventListener("click", handleAddToCart));
};
